import { useEffect, useState } from "react";
import { gapi, fmtDateTime } from "../api";
import { PageHeader, Panel, Badge } from "../components/ui";

const TONE = { attivo: "green", da_configurare: "amber", non_disponibile: "neutral", errore: "red" };
const LABEL = { attivo: "Attivo", da_configurare: "Da configurare", non_disponibile: "Non disponibile", errore: "Errore" };

export default function FontiDati() {
  const [d, setD] = useState(null);
  useEffect(() => { gapi.get("/market/sources").then((r) => setD(r.data)); }, []);
  return (
    <div data-testid="g-sources-page">
      <PageHeader eyebrow="Annunci e mercato" title="Fonti dati" desc="Stato reale dei collegamenti. Pubblicare i nostri annunci su un portale e cercare gli annunci di terzi sono servizi diversi." />
      {d && <p className="text-sm rounded-xl bg-amber-50 text-amber-900 px-4 py-3 mb-4" data-testid="sources-note">{d.nota}</p>}
      <div className="grid lg:grid-cols-2 gap-4">
        {(d?.items || []).map((s) => (
          <Panel key={s.id} testid={`source-${s.id}`}>
            <div className="flex items-center gap-2 mb-2"><b className="text-base">{s.portale}</b><Badge tone={TONE[s.stato]} testid={`source-status-${s.id}`}>{LABEL[s.stato]}</Badge></div>
            <dl className="text-sm space-y-1.5">
              <div><dt className="text-xs text-anthracite/50">Metodo di collegamento</dt><dd>{s.metodo}</dd></div>
              <div><dt className="text-xs text-anthracite/50">Copertura disponibile</dt><dd>{s.copertura}</dd></div>
              <div><dt className="text-xs text-anthracite/50">Funzioni e campi accessibili</dt><dd>{s.campi}</dd></div>
              <div><dt className="text-xs text-anthracite/50">Limiti, credenziali o servizi a pagamento</dt><dd>{s.limiti} · <b>{s.credenziali}</b></dd></div>
              <div><dt className="text-xs text-anthracite/50">Ultimo aggiornamento riuscito</dt><dd>{s.ultimoAggiornamento ? fmtDateTime(s.ultimoAggiornamento) : "mai (nessun collegamento automatico)"}{s.annunci ? ` · ${s.annunci} annunci in archivio` : ""}</dd></div>
            </dl>
          </Panel>))}
      </div>
    </div>
  );
}
